<script setup lang="ts">
import { FindGameSeriesDocument, type FindGameSeriesQuery, type GameSeriesListItemFragment } from "../graphql/types"
import { useAsyncEntitySearch } from "../forms/composables/useAsyncEntitySearch"
import AsyncBadgeCombobox from "../forms/components/AsyncBadgeCombobox.vue"

const modelValue = defineModel<GameSeriesListItemFragment[]>({ default: () => [] })

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false })

const { items, loading, hasMore, search, loadMore } = useAsyncEntitySearch<FindGameSeriesQuery, GameSeriesListItemFragment>({
  queryDocument: FindGameSeriesDocument,
  extract: (r) => r.findGameSeries
})
</script>

<template>
  <AsyncBadgeCombobox
    v-model="modelValue"
    :items="items"
    :loading="loading"
    :has-more="hasMore"
    :search="search"
    :label-fn="(s) => s.name"
    placeholder="Spieleserie suchen..."
    :disabled="disabled"
    @load-more="loadMore"
  />
</template>
